export class Partenaire {
  public id: number;
  public intitule: string;

  constructor(init?: Partial<Partenaire>) {
    Object.assign(this, init);
  }
}